import { PersonDetailsContext } from "pages/PersonDetails";
import { useContext } from "react";

export default function NoLink() {
  const { user } = useContext(PersonDetailsContext);
  return (
    <div className="w-full text-center space-y-5 py-16">
      <p className="text-lg text-[#5E6278] font-semibold">
        {user.nickName} has no public links!
      </p>
      <p className="text-sm text-[#9A9EB1] font-medium">
        You can see only public contents of users on the web app!
      </p>
    </div>
  );
}
